import React, { useMemo } from "react";
import "./websiteBuilderSkeleton.scss";

interface IWebsiteBuilderSkeletonProps {
  width?: number;
  height?: number;
  fill?: boolean;
  circle?: boolean;
  borderRadius?: number;
}

export function WebsiteBuilderSkeleton(props: IWebsiteBuilderSkeletonProps) {
  const {
    width,
    height,
    fill,
    circle,
    borderRadius = 5,
  } = props;

  const widthProperty = useMemo(() => {
    if (width) {
      return `${width}px`;
    } else if (fill) {
      return "100%";
    } else {
      return "0px";
    }
  }, [width, fill]);

  const heightProperty = useMemo(() => {
    if (height) {
      return `${height}px`;
    } else if (fill) {
      return "100%";
    } else {
      return "0px";
    }
  }, [height, fill]);

  return (
    <div
      className="website-builder-skeleton"
      style={{
        width: widthProperty,
        height: heightProperty,
        borderRadius: circle ? "50%" : `${borderRadius}px`,
      }}
    />
  );
}